function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.5 0a6.5 6.5 0 110 13h-10a6.5 6.5 0 110-13h10zm0 1a5.5 5.5 0 100 11 5.5 5.5 0 000-11z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 23,
    height: 13
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/toggle-on.dfddbab6.svg";
export { SvgComponent as ReactComponent };